import { HEADER_MINIMUM_Z_INDEX } from '@/scripts/constants/header'

export const PANEL_Z_INDEX = HEADER_MINIMUM_Z_INDEX + 5
